import { Flex, Spinner } from '@chakra-ui/react';

const Loader = ({height}) => <Flex
  w="100%"
  h={(!!height) ? height : "500px"}
  bg="rgba(255,255,255,0)"
  alignItems="center"
  justifyContent="center"
>
  <Spinner
    thickness="4px"
    speed="0.65s"
    emptyColor="white"
    color="#11365f"
    size="xl"
  />
</Flex>
export default Loader;